<template>
  <div class="header">
    <img class="logo" src="../../../assets/img/logo.png" alt />
    <!-- <img v-show="!showDownload" class="copyright" src="../../../assets/images/website/TAL.png" alt />
    <div v-show="showDownload" class="download">
        <i class="icon iconfont iconxiazai1">
      </i>
      <a href="https://toolplugin.jiaoyanyun.com/api/plugin/video-tool/download-latest">立即下载</a>
    </div>-->
    <div class="tab">
      <div class="tab-item" v-for="(tab, index) in tabs" :key="index" :class="{ active: currentNav === tab.type }" @click="handlerSwitchRouter(tab)">
        {{ tab.tab }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Head',
  data() {
    return {
      showDownload: false,
      tabs: [
        {
          tab: '产品介绍',
          name: 'Index',
          type: 'index'
        },
        {
          tab: '创作者服务',
          name: 'Creator',
          type: 'creator'
        }
      ]
    };
  },
  props: ["scrollTop"],
  watch: {
    scrollTop: {
      handler(val, old) {
        if (val > 500) {
          this.showDownload = true;
        } else {
          this.showDownload = false;
        }
      }
    }
  },
  computed: {
    currentNav() {
      return this.$route.meta.type
    }
  },
  methods: {
    OSisMac() {
      var agent = navigator.userAgent.toLowerCase();
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);

      if (isMac) {
        return true;
      }
      return false;
    },
    handlerSwitchRouter(item) {
      const { name } = item
      const { name: routeName } = this.$route

      if (routeName === name) {
        return
      }

      this.$router.push({ name })

    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/index.scss';
.header {
  width: 1200px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 50px;
  line-height: 50px;
  background-color: #fff;

  .logo {
    height: 28px;
  }
  .copyright {
    height: 40px;
    width: 266px;
  }
  .download {
    width: 124px;
    height: 38px;
    background: #435fff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    &:hover {
      background: rgba(#435fff, 0.8);
    }
    a {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      text-decoration: none;
    }
    .icon {
      margin-right: 4px;
    }
  }
}
.tab {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-end;
  align-items: center;
  .tab-item {
    font-size: 16px;
    font-weight: 400;
    color: #49505c;
    margin-left: 60px;
    cursor: pointer;
  }
  .active {
    font-weight: 600;
    color: #212329;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/components/header.vue